<template>
  <div v-if="product && product.isPair" class="product-pair-controls">
    <h6 class="pair-title">
      <span class="pair-title_grey">{{ messages.quantity }}:</span>
      {{ getSelectedText }}
    </h6>
    <div class="pair-controls-items">
      <button
        :class="{
          'pair-controls-button_active': isPairSelected && product.price.quantity == 1,
          'pair-controls-button_error': !isPairSelected,
        }"
        class="pair-controls-button"
        @click="handlerChangePair(1)"
      >
        {{ product?.type }}
      </button>
      <button
        :class="{
          'pair-controls-button_active': isPairSelected && product.price.quantity == 2,
          'pair-controls-button_error': !isPairSelected,
        }"
        class="pair-controls-button"
        @click="handlerChangePair(2)"
      >
        {{ messages?.pair }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from '@/store';

const { state, commit, dispatch } = useStore();

const product = computed(() => state.product.data.product);
const isPairSelected = computed(() => state.product.data.isPairSelected);
const messages = computed(() => state.product.data.messages);

const getSelectedText = computed(() => {
  if (isPairSelected.value) {
    if (product.value?.price?.quantity == 1) {
      return product.value?.type;
    }
    return messages.value?.pair;
  }
});

const handlerChangePair = async (quantity: number) => {
  await dispatch('product/changeQuantity', { quantity });
  commit('product/selectPair', true);
};
</script>

<style lang="scss" scoped>
.product-pair-controls {
}
.pair-controls-items {
  display: flex;
  grid-gap: 8px;
  margin-bottom: 16px;
  @include point-md {
    margin-bottom: 24px;
  }
}
.pair-controls-button {
  display: flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  height: 32px;
  padding: 0 12px;
  border-radius: 100px;
  transition: 0.2s linear background-color, 0.2s linear border-color, 0.2s linear color;

  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  text-transform: uppercase;
  &_active {
    background-color: var(--background-black);
    border-color: var(--background-black);
    color: #fff;
  }
  &_error {
    border-color: var(--color-red);
  }
}
.pair-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  margin-bottom: 12px;
  &_grey {
    color: var(--color-dark-grey);
  }
}
</style>
